import { DELETE_AMENITY_FAILURE, DELETE_AMENITY_REQUEST, DELETE_AMENITY_SUCCESS, GET_AMENITY_FAILURE, GET_AMENITY_REQUEST, GET_AMENITY_SUCCESS, POST_AMENITY_FAILURE, POST_AMENITY_REQUEST, POST_AMENITY_SUCCESS, POST_API_FAILURE, PUT_AMENITY_FAILURE, PUT_AMENITY_REQUEST, PUT_AMENITY_SUCCESS} from "../../../Utils/Constant";

  export const AmenityRequest = (payload) => {
    return {
      type: GET_AMENITY_REQUEST,
      payload: payload,
    };
  };
  
  export const AmenitySuccess = (data) => {
    return {
      type: GET_AMENITY_SUCCESS,
      payload: data,
    };
  };
  
  export const AmenityFailure = (error) => {
    return {
      type: GET_AMENITY_FAILURE,
      payload: error,
    };
  };
  
  //add room
   export const addAmenityRequest = (payload) => {
      return {
        type: POST_AMENITY_REQUEST,
        payload: payload,
      };
    };
    
    export const addAmenitySuccess = (data) => {
      return {
        type: POST_AMENITY_SUCCESS,
        payload: data,
      };
    };
    
    export const addAmenityFailure = (error) => {
      return {
        type: POST_AMENITY_FAILURE,
        payload: error,
      };
    };

    // update
    export const updateAmenityRequest = (payload) => {
        return {
          type: PUT_AMENITY_REQUEST,
          payload: payload,
        };
      };
      
      export const updateAmenitySuccess = (data) => {
        return {
          type: PUT_AMENITY_SUCCESS,
          payload: data,
        };
      };
      
      export const updateAmenityFailure = (error) => {
        return {
          type: PUT_AMENITY_FAILURE,
          payload: error,
        };
      };

    //deleteroom
    export const deleteAmenityRequest = (payload) => {
      return {
        type: DELETE_AMENITY_REQUEST,
        payload: payload,
      };
    };
    
    export const deleteAmenitySuccess = (data) => {
      return {
        type: DELETE_AMENITY_SUCCESS,
        payload: data,
      };
    };
    
    export const deleteAmenityFailure = (error) => {
      return {
        type: DELETE_AMENITY_FAILURE,
        payload: error,
      };
    };
    